import { useState } from "react";
import { useTranslation } from "react-i18next";
import { QuestionCircleOutlined } from "@ant-design/icons";
import HelpCentreDrawer from "./HelpCentreDrawer";

const HelpCentre = () => {
    const { t } = useTranslation("helpCentre");
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                aria-label={t("getHelp")}
                className="pointer-events-auto fixed bottom-8 right-8 z-[100] flex items-center gap-2 rounded-full border border-gray-200 bg-white px-4 py-2.5 text-sm font-medium text-gray-700 shadow-lg transition-all hover:-translate-y-0.5 hover:shadow-xl max-lg:bottom-6 max-lg:right-6 max-lg:px-3">
                <QuestionCircleOutlined className="text-base text-gray-500" />
                {t("getHelp")}
            </button>

            <HelpCentreDrawer open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default HelpCentre;
